import { Injectable } from '@angular/core';
import { ChartFilterHandlerService } from '@shared-lib/shared-services/chart-filter-handler.service';

@Injectable({
  providedIn: 'root',
})
export class CustomChartFilterHandlerService extends ChartFilterHandlerService {
  override shouldReload(filters: any, widgetId: string): boolean {
    if (filters?.skipReload) return false;
    if (filters?.filterListener) {
      const listenerData = filters.filterListener;
      const listeners = Array.isArray(listenerData)
        ? listenerData
        : String(listenerData)
            .split(',')
            .map((s: string) => s.trim());

      return listeners.includes(String(widgetId || '').trim());
    }
    return true;
  }

  private isEmptySelection(value: any): boolean {
    if (value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') {
      const values = Object.values(value);
      if (values.length === 0) return true;
      return values.every((v) => this.isEmptySelection(v));
    }
    return false;
  }

  private clearKeys(data: any): void {
    const keys: string[] = Array.isArray(data?.filterKey)
      ? data.filterKey
      : String(data?.filterKey || '')
          .split(',')
          .map((k: string) => k.trim())
          .filter(Boolean);

    if (!keys.length) return;

    const listener = data?.filterListener || data?.filterListner;
    keys.forEach((key, index) => {
      const isLast = index === keys.length - 1;
      if (isLast) {
        this.globalFilterService.resetFilterSelection(key, false, listener);
      } else {
        this.globalFilterService.deleteKey(key, false);
      }
    });
  }

  /**
   * Override hook for updateFilterSelection.
   *
   * IMPORTANT:
   * - We now fully delegate to the base implementation so that:
   *   - Single-select and multi-select (array) values are merged into the
   *     existing global filter state instead of replacing all filters.
   *   - Toggle behavior (click again to clear) continues to work as implemented
   *     in the shared library.
   *
   * If you ever need custom pre/post processing, keep it non-destructive and
   * never call updateAllFilters() here, otherwise other widget filters will be
   * wiped out on every multi-select.
   */
  override updateFilterSelection(data: any, name: string | any | any[]): void {
    console.log('[CustomChartFilterHandler] Handling updateFilterSelection', { data, name });

    // Explicit clear path: empty legend/slice/category selections should delete keys,
    // not store empty arrays in requestParams.
    if (this.isEmptySelection(name)) {
      this.clearKeys(data);
      return;
    }

    // Delegate to base implementation (handles both single and multi-select).
    super.updateFilterSelection(data, name);
  }
}
